__turbopack_context__.v({
  "input": "yRB76W_input",
  "input--with-leading-icon": "yRB76W_input--with-leading-icon",
  "input--with-trailing-icon": "yRB76W_input--with-trailing-icon",
  "input--without-label": "yRB76W_input--without-label",
  "input__icon": "yRB76W_input__icon",
  "input__icon--leading": "yRB76W_input__icon--leading",
  "input__icon--trailing": "yRB76W_input__icon--trailing",
  "input__label": "yRB76W_input__label",
  "wrapper": "yRB76W_wrapper",
});
